import React, { Component } from "react";
import UserImage from "./../../../assets/images/user.jpg";
import FilterActiveIcon from "./../../../icons/filteractiveicon";
import FilterIcon from "./../../../icons/filtericon";
import service from "../../../../src/services";
import Loader from "../../loader";
import moment from "moment";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import ErrorPopUp from '../../errorPopUp';

import ReactPaginate from "react-paginate";

let genreData;
let sub;
let statusFilterList = [];
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class LiveScreeningList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorPopup:false,
      activetab: 0,
      exploreLiveScreeningList: [],
      liveScreeningList: [],
      loaderFlag: false,
      offset: 0,
      perPage: 50,
      currentPage: 0,
      statusArray: [
        { assign: "Live", list: 1, value: false },
        { assign: "Disable", list: 2, value: false },
      ],
    };
    this.apiserve = new service();
  }

  componentDidMount = () => {
    let currentPage = localStorage.getItem('currentPage')
    if(currentPage) {
    this.setState(
    {
    offset: parseInt(localStorage.getItem("offset")),
    perPage: parseInt(localStorage.getItem("perPage")),
    currentPage: parseInt(localStorage.getItem("currentPage")),
    },
    () =>
    this.getLiveScreeningList(this.state.offset, this.state.perPage)
    );
    }else{
            this.setState({
        offset:0,
        perPage:50,
        currentPage:0
    },
    () =>
        this.getLiveScreeningList(this.state.offset, this.state.perPage))
    }
    
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "fpg|liveScreening|getList":
          if(!response.error){
          this.setState({
            liveScreeningList: response.data.docs,
            exploreLiveScreeningList: response.data.docs,
            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
            loaderFlag: false,
          });
        }else{
          this.setState({
            errorPopup:true,
            errorMsg: response.data.error ? response.data.error : response.data        
       })
        }

          break;

        default:
          break;
      }
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
    statusFilterList = [];
  
  };

  errorMsgPopup = () => {
    this.setState({
        errorPopup:false
    })  
  }

  getLiveScreeningList = (skip, limit) => {
    this.setState({
      loaderFlag: true
  })
    var data = {
      page: skip,
      limit: limit,
    };
    this.apiserve.sendevent("fpg|liveScreening|getList", data);
  };

  editLiveScrening = (item) => {
    // this.props.LiveSceeringEditData(item);

    // this.props.history.push({
    //   pathname: "/admin-detail-view",
    //   callFrom: 3,
    // });
    
      this.props.NewFrontierEditData()
      this.props.filmEditData()
      this.props.TalkEventEditData()
      this.props.LiveSceeringEditData(item)
      this.props.CurrentTab(3)
      // this.props.dispatch({type: 'CurrentTab', res: 3})
      // this.props.history.push({
      //   pathname: "/admin-detail-view",
      //   callFrom:3
      // });
  };


  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;
    
    // page scroll top
    var tbl = document.querySelector(".film_list_table");
    tbl.scrollTo(0, 0);

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        loaderFlag: true,
      },
      () => {
        localStorage.setItem('currentPage',this.state.currentPage)
        localStorage.setItem('offset',offset)
        localStorage.setItem('perPage',this.state.perPage)
        this.getFilmList(offset, this.state.perPage);
      }
    );
  };

  StatusFilter = (e, selectedInex, isClearStatusType = false) => {
    let index = selectedInex;
    let event = e && e.target && e.target.checked;
    let approvePassList = [...this.state.statusArray];
    approvePassList.forEach((key, i) => {
      if (i === index) {
        approvePassList[i].value = event;
      }
      if (isClearStatusType) {
        approvePassList[i].value = false;
        statusFilterList = [];
      }
    });
    this.setState(
      {
        ...this.state,
        statusArray: approvePassList,
        currentPage: 0,
      },
      () => {
        if (event) {
          if (index !== null) {
            statusFilterList = [
              ...statusFilterList,
              this.state.statusArray[index].list,
            ];
          }
        } else {
          if (index !== null) {
            let tempArray = statusFilterList.filter(
              (d) => d !== this.state.statusArray[index].list
            );
            statusFilterList = tempArray;
          }
        }
        this.getFilmFilter(
          this.state.offset,
          this.state.perPage,
          isClearStatusType
        );
      }
    );
  };

  getFilmFilter = (skip, limit, isClearStatusType) => {
    let data = {
      page: 1,
      limit: limit,
    };

    if (!isClearStatusType && statusFilterList && statusFilterList.length) {
      data.status = statusFilterList;
    }

    this.apiserve.sendevent("fpg|liveScreening|getList", data);
  };

  render() {
    const { exploreLiveScreeningList, statusArray } = this.state;
    return (
      <>
        <div className="table_wrap film_list_table">
          <table>
            <thead>
            <tr>
              <th></th>
              <th>Partner Theater</th>
              <th>Location</th>
              <th>Accessibility</th>
              <th>
                <span className="d_flex d_flex_align_center">
                  Status
                  {statusFilterList && statusFilterList.length ? (
                    <FilterActiveIcon />
                  ) : (
                    <FilterIcon />
                  )}
                </span>
                <div className="tabelData_popup">
                  <form>
                    <div className="customCheck">
                      <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                        <p
                          className="link"
                          onClick={() => this.StatusFilter(null, null, true)}
                        >
                          Clear All
                        </p>
                      </div>

                      <div className="customCheckBox">
                        {statusArray.map((item, i) => (
                          <div className="customCheckBox">
                            <input
                              type="checkbox"
                              id={"status" + item.list}
                              name={"status" + item.list}
                              value={item.list ? true : false}
                              checked={item.value ? true : false}
                              onClick={(e) => this.StatusFilter(e, i)}
                            />
                            <label htmlFor={"status" + item.list}>
                              {item.assign}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </form>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
              {exploreLiveScreeningList &&
                exploreLiveScreeningList.length > 0 &&
                exploreLiveScreeningList.map((item) => (
                  <tr onClick={() => this.editLiveScrening(item._id)} className={`pointer ${item.status === 2 ? 'disable': ''}`}>
                    <td style={{width:"120px"}}>
                        <div className="partner_banner">
                          <img src={
                            item.image ? this.apiserve.imageUrl + item.image : '/images/image-placeholder.png'}
                          />
                        </div>
                    </td>
                    <td style={{width:"300px"}}>
                        <div className="film_desc ml_0">
                          <h3>{item.name}</h3>
                        </div>
                    </td>
                    <td style={{width:"300px"}}>
                      <div className="film_desc ml_0">
                          {item.location.city + ' ' + item.location.state}
                      </div>
                    </td>
                    <td style={{width:"900px"}}>
                      <div>
                        {item.accessibility &&
                          item.accessibility.map((e) => {
                            return <p>{e.name}</p>;
                          })}
                      </div>
                    </td>
                    <td style={{width:"150px"}}>
                      <div>
                        <p>
                          {item.status === 1
                            ? "Live"
                            : item.status === 2
                            ? "Disabled"
                            : ""}
                        </p>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* Loader */}
          {this.state.loaderFlag ? (
              <Loader />
          ) : (
              ""
          )}
        </div>
        {/* ReactPaginate  */}
        {exploreLiveScreeningList &&
        exploreLiveScreeningList.length &&
        exploreLiveScreeningList ? (
          <div className="custom-pagination">
            <ReactPaginate
              previousLabel={""}
              nextLabel={""}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={this.state.currentPage}
            />
          </div>
        ) : (
          ""
        )}
         {this.state.errorPopup ? 
                  <ErrorPopUp
                  errorMsg={this.state.errorMsg}
                  errorMsgPopup={this.errorMsgPopup}
                  />    
              : ''
          }
      </>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveScreeningList);
